module.exports = __webpack_public_path__ + "static/media/Bellsprout_gaussian2.33651b3a.png";